import RolesPermissions from '../../config/rolesPermissions';
import { ROLE_ADMINISTRATOR } from '../../constants/roles';

/**
 * Get permissions of a role
 *
 * @param {string} role The role
 * @returns {Array<String>} The permissions
 */
export const getRolePermissions = (role) => {
  if (typeof role !== 'string')
    throw new Error('Role must be a string. Use getRolesPermissions if role is an array');

  // Return an array of unique permissions
  return [...new Set(RolesPermissions[role])] ?? [];
};

/**
 * Get permissions of multiple role
 *
 * @param {Array<String>} roles The roles
 * @returns {Array<String>} The permissions
 */
export const getRolesPermissions = (roles) => {
  if (!Array.isArray(roles))
    throw new Error('Role must be an array. Use getRolePermissions if role is a string');

  const rolesPermissions = roles.reduce((permissions, role) => {
    permissions.push(...getRolePermissions(role));
    return permissions;
  }, []);

  // Return an array of unique permissions
  return [...new Set(rolesPermissions)];
};

/**
 * Check if roles has the admin
 *
 * @param {Array<String>} roles The roles
 * @returns {boolean}
 */
export const hasAdminRole = (roles) => {
  if (!Array.isArray(roles)) throw new Error('Roles must be an array');

  return roles.includes(ROLE_ADMINISTRATOR);
};
